import React from 'react';
import cn from 'classnames';
import Features from './Features';
import QuoteForm from './QuoteForm';
import baseStyles from '@/dataroom/ui/components/Landing/dealvdr/tenantDealvdrStyles.module.scss';
import styles from './quote.module.scss';

const Quote = () => (
  <div className={ cn(styles.quoteWrp, baseStyles.lgContainer) }>
    <div className={ styles.quote }>
      <Features />
      <div className={ styles.quoteFormWrp }>
        <QuoteForm />
      </div>
    </div>
  </div>
);

export default Quote;
